import type { AddRegistryItemPayloadBySource } from '../Catalog.controller';
import { isDeliverableCatalogItem } from './interpretItemType';

type AddRefusalHandlers = Readonly<{
  onDeliverableAddRefused?: () => void;
  onUniversalSearchAddRefused?: () => void;
}>;

/** A Joy store item: ships only within the US. Not a cash fund, a charity, or a gift pasted from another store. */
export const isJoyStoreAdd = (input: AddRegistryItemPayloadBySource) => input.source !== 'universalSearch' && isDeliverableCatalogItem(input.payload.product);

/** The refusal that applies to this add, if any. */
export const getAddRefusalHandler = (input: AddRegistryItemPayloadBySource, { onDeliverableAddRefused, onUniversalSearchAddRefused }: AddRefusalHandlers) => {
  if (input.source === 'universalSearch') return onUniversalSearchAddRefused;
  if (isJoyStoreAdd(input)) return onDeliverableAddRefused;
  return undefined;
};
